import React from "react";
import './privacy.css';

const Privacy = ()=>{
    return(
        <>
        <div className="privacy">
            <div className="privacy-container">
                <p className="header">Privacy Policy</p>
                <p className="privacy-content">
                This website does not automatically capture any specific personal information from you, (like name, phone number or e-mail address), that allows us to identify you individually.

Wherever the Website requests you to provide personal information, you will be informed for the particular purposes for which the information is gathered, and adequate security measures will be taken to protect your personal information.

We do not sell or share any personally identifiable information volunteered on the website site to any third party. Any information provided to this website will be protected from loss, misuse, unauthorized access or disclosure, alteration, or destruction.

We gather certain information about the user of this website, such as Internet protocol (IP) addresses, domain name, browser type, operating system, the date and time of the visit and the pages visited. We make no attempt to link these addresses with the identity of individuals visiting our site unless an attempt to damage the site has been detected.

When visitors provide us their personal information, such as contact information, we may use it to:Communicate and respond to their inquiries and requests, Provide updates via emails, and Conduct surveys.

Agrix Agrotech Private Limited is an Indian company following India’s law while your personal information, transmitted to us by service providers in your jurisdiction where we do not operate, may not be provided to us with the same level of privacy protection as you are entitled to. By sharing any information with us, you acknowledge any such transfer, storage or use.

As our company and services evolve, our privacy policy may be revised to reflect those changes, from time to time. We reserve the right to amend this privacy policy at any time, for any reason. Whenever we change our privacy policy, we post the changes here.
                </p>
            </div>
        </div>
        
        </>
    )
}

export default Privacy;